import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import Dropzone from 'react-dropzone';
import styles from './uploadDropzone.module.scss';
export const UploadDropzone = ({ disabled, onDrop, onReject, dropzoneText, className, maxFileSize, allowedFileTypes, }) => {
    const handleOnDrop = (acceptedFiles, rejectedFiles) => {
        if (disabled) {
            return;
        }
        if (acceptedFiles.length > 0) {
            onDrop(acceptedFiles[0]);
        }
        else if (rejectedFiles.length > 0) {
            if (maxFileSize <= rejectedFiles[0].size) {
                onReject(rejectedFiles[0], 'size');
            }
            else {
                onReject(rejectedFiles[0], 'type');
            }
        }
    };
    return (_jsx(Dropzone, Object.assign({ onDrop: handleOnDrop, accept: allowedFileTypes, multiple: false, className: className || styles.dropzone, maxSize: maxFileSize, disableClick: disabled }, { children: dropzoneText && _jsx(Text.Paragraph, { children: dropzoneText }) })));
};
